import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import bgImg from "../../../assets/images/Texture BG.jpg";
import loginImg from "../../../assets/images/Log in Image.png";
import logo from "../../../assets/images/86294Sized_AdVendoo_falt_RK_01.png";
import { MdRemoveRedEye } from "react-icons/md";
import { FaEyeSlash } from "react-icons/fa";
import { getCurrentUser, login } from "../../../api/user.api";
import { errorMsg } from "../../../utils/notifications";

function Login() {
  const initialData = {
    email: "",
    password: "",
    role: "admin",
  };
  const [loginData, setLoginData] = useState(initialData);
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();
  useEffect(() => {
    const checkLoggedIn = async () => {
      try {
        const token = localStorage.getItem("token");
        if (token) {
          const userResponse = await getCurrentUser();
          const userRole = userResponse?.data?.user?.role;
          if (userRole === "admin") {
            navigate("/dashboard");
          } else {
            navigate("/");
          }
        }
      } catch (error) {
        console.error("Error checking user login:", error);
      }
    };

    checkLoggedIn();
  }, [navigate]);

  const handleTogglePassword = (fieldName) => {
    if (fieldName === "password") {
      setShowPassword(!showPassword);
    }
  };

  const handleChange = (e) => {
    setLoginData({
      ...loginData,
      [e.target.name]: e.target.value,
    });
  };

  const handleLogin = async (e) => {
    e.preventDefault();

    try {
      await login(loginData.email, loginData.password);
      console.log(loginData);
      const userResponse = await getCurrentUser();
      const userRole = userResponse?.data?.user?.role;
      if (userRole === "admin") {
        navigate("/dashboard");
      } else if (userRole !== "admin") {
        errorMsg("Oops", "Admin not found");
      }
    } catch (error) {
      errorMsg("Oops", error?.response?.data?.message);
    }
  };
  return (
    <>
      <div className="grid grid-cols-12">
        <div className="h-screen col-span-12 lg:col-span-6 md:col-span-12  ">
          <div className="pt-8">
            <img
              className="ml-5 md:ml-12 lg:ml-12 h-10 w-auto"
              src={logo}
              alt="Your Company"
            />
          </div>
          <div className=" py-5 px-5 flex items-center justify-center h-3/4 md:h-[90%] lg:h-[90%]">
            <div className="px-3 lg:px-0 md:px-0 w-full md:w-3/5 lg:w-3/5">
              <div>
                <h2 className="text-2xl font-bold leading-9 tracking-tight text-gray-900">
                  Welcome to <span className="text-yellowColor">AdVendoo</span>
                </h2>
                <p className="text-base leading-6 text-gray-400 font-semibold">
                  Login to your account?{" "}
                </p>
              </div>

              <div className="mt-5">
                <div>
                  <form onSubmit={handleLogin} method="POST" className="">
                    <div className="pb-4">
                      <div className="grid grid-cols-1 gap-x-6 gap-y-3.5 sm:grid-cols-6">
                        <div className="sm:col-span-full">
                          <label
                            htmlFor="email"
                            className="block text-base font-semibold leading-6 text-gray-800"
                          >
                            Email
                          </label>
                          <div className="mt-2">
                            <input
                              id="email"
                              name="email"
                              type="email"
                              placeholder="Email"
                              value={loginData.email}
                              onChange={handleChange}
                              autoComplete="email"
                              className="text-base font-medium bg-neutral-100 bg-opacity-80 px-3 block w-full rounded-md border-0 outline-0 py-2.5 text-gray-600 placeholder:text-gray-400 border-2 border-transparent focus:border-2 focus:border-yellowColor sm:leading-6"
                              required
                            />
                          </div>
                        </div>

                        <div className="sm:col-span-full relative">
                          <label
                            htmlFor="password"
                            className="block text-base font-semibold leading-6 text-gray-800"
                          >
                            Password
                          </label>
                          <div className="mt-2 relative">
                            <input
                              type={showPassword ? "text" : "password"}
                              name="password"
                              placeholder="Password"
                              value={loginData.password}
                              onChange={handleChange}
                              id="password"
                              className="text-base font-medium bg-neutral-100 bg-opacity-80 px-3 pr-10 block w-full rounded-md border-0 outline-0 py-2.5 text-gray-600 placeholder:text-gray-400 border-2 border-transparent focus:border-2 focus:border-yellowColor sm:leading-6"
                              required
                            />
                            {/* Eye icon */}
                            <button
                              className="absolute inset-y-0 right-0 flex items-center pr-3"
                              onClick={() => handleTogglePassword("password")}
                              type="button"
                            >
                              {showPassword ? (
                                <FaEyeSlash className="cursor-pointer text-gray-400 text-2xl" />
                              ) : (
                                <MdRemoveRedEye className="cursor-pointer text-gray-400 text-2xl" />
                              )}
                            </button>
                          </div>
                        </div>

                        <div className="col-span-full">
                          <div className="flex items-center justify-between">
                            <div className="flex items-center">
                              <input
                                id="termsAndConditions"
                                name="termsAndConditions"
                                type="checkbox"
                                className="h-4 w-4 rounded border-gray-300 text-yellowColor focus:ring-yellowColor"
                              />
                              <label
                                htmlFor="termsAndConditions"
                                className="ml-3 block text-lg font-medium leading-6 text-gray-400"
                              >
                                Remember me
                              </label>
                            </div>
                            <Link
                              to="/login"
                              className="text-lg font-medium text-yellowColor hover:text-yellowColor"
                            >
                              Forgot Password?
                            </Link>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div>
                      <button
                        type="submit"
                        className="flex w-full justify-center rounded-md bg-yellowColor px-3 py-2.5 text-base font-semibold leading-6 text-dark shadow-sm hover:bg-opacity-90 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-yellowColor"
                      >
                        Sign In
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="h-screen hidden lg:block col-span-12 lg:col-span-6  sm:col-span-12 relative">
          <img
            className="h-full w-full object-cover"
            src={bgImg}
            alt="bg img"
          />
          <div className="absolute inset-0 flex items-center justify-center">
            <div className="text-center text-white">
              <div className="flex items-center justify-center flex-col">
                <h1 className="w-96 my-4 text-4xl ">Welcome Back</h1>
                <p className="w-96 mb-5 text-xl">
                  Discover new oppurtunities in the Wold of ads
                </p>
              </div>
              <img className="w-auto h-96" src={loginImg} alt="bg img" />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Login;
